module.exports = __webpack_public_path__ + "img/abdomen.5a8936db.png";